import { GenericService } from "./Generic.service";

export class TermoService extends GenericService<any> {
    readonly URI: string = "Termo";

    constructor() {
        super();
        this.setUri(this.URI);
    }

    public async uploadTermo(pacienteId: string, file: File, onProgress?: (progress: number) => void) {
        const formData = new FormData();
        formData.append("file", file);
        return await super.postByResourceWithConfig(formData, `Upload/${pacienteId}`, {
            onUploadProgress: (progressEvent: any) => {
                if (onProgress) {
                    const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    onProgress(progress);
                }
            }
        });
    }

    public async listarTermos(pacienteId: string) {
        return await super.getByResource(`Listar/${pacienteId}`);
    }

    public async downloadTermo(termoId: string) {
        return await super.getByResourceBlob(`Download/${termoId}`);
    }
}
